/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestChatworkSendMessageRequest
 */
export interface RequestChatworkSendMessageRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestChatworkSendMessageRequest
     */
    createdUserId: number;
    /**
     * 
     * @type {string}
     * @memberof RequestChatworkSendMessageRequest
     */
    message?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestChatworkSendMessageRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestChatworkSendMessageRequest interface.
 */
export function instanceOfRequestChatworkSendMessageRequest(value: object): value is RequestChatworkSendMessageRequest {
    if (!('createdUserId' in value) || value['createdUserId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestChatworkSendMessageRequestFromJSON(json: any): RequestChatworkSendMessageRequest {
    return RequestChatworkSendMessageRequestFromJSONTyped(json, false);
}

export function RequestChatworkSendMessageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestChatworkSendMessageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'createdUserId': json['created_user_id'],
        'message': json['message'] == null ? undefined : json['message'],
        'userId': json['user_id'],
    };
}

export function RequestChatworkSendMessageRequestToJSON(json: any): RequestChatworkSendMessageRequest {
    return RequestChatworkSendMessageRequestToJSONTyped(json, false);
}

export function RequestChatworkSendMessageRequestToJSONTyped(value?: RequestChatworkSendMessageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created_user_id': value['createdUserId'],
        'message': value['message'],
        'user_id': value['userId'],
    };
}

